import { SaasApiClient } from '@fourthwall/services/dist/SaasApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useCancelSubscriptionPlanMutation = createMutationHook(
  SaasApiClient.cancelSubscriptionPlan,
  {
    mutationKey: ['cancelSubscriptionPlanMutation'],
  },
)
